import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getuserProfileHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "userProfile", ...action.payload }),
		);
		yield put({
			type: types.GET_USER_PROFILE_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_USER_PROFILE_ERROR,
			payload,
		});
	}
}

export function* getuserProfileWatcherSaga() {
	yield takeLatest(types.GET_USER_PROFILE_START, getuserProfileHandlerSaga);
}

//delete

function* deleteuserProfileHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("userProfile", action.payload),
		);
		yield put({
			type: types.DELETE_USER_PROFILE_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_USER_PROFILE_ERROR,
			payload,
		});
	}
}

export function* deleteuserProfileWatcherSaga() {
	yield takeLatest(
		types.DELETE_USER_PROFILE_START,
		deleteuserProfileHandlerSaga,
	);
}
